import { z } from "zod";
import { isoDateSchema, objectIdSchema } from "./common";
export const webhookEventEnum = z.enum([
    "message.status.changed",
    "message.received",
    "device.online",
    "device.offline",
    "quota.updated",
    "batch.progress",
]);
export const webhookSchema = z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    url: z.string().url(),
    events: z.array(webhookEventEnum).min(1),
    secret: z.string(),
    isActive: z.boolean(),
    customHeaders: z.record(z.string(), z.string()).default({}),
    createdAt: isoDateSchema,
});
export const webhookPublicSchema = webhookSchema.omit({ secret: true, userId: true });
export const createWebhookSchema = z.object({
    url: z.string().url(),
    events: z.array(webhookEventEnum).min(1),
    customHeaders: z.record(z.string(), z.string()).optional(),
});
export const updateWebhookSchema = z.object({
    url: z.string().url().optional(),
    events: z.array(webhookEventEnum).min(1).optional(),
    isActive: z.boolean().optional(),
    customHeaders: z.record(z.string(), z.string()).optional(),
});
export const webhookDeliverySchema = z.object({
    _id: objectIdSchema,
    webhookId: objectIdSchema,
    messageId: objectIdSchema.nullable(),
    attempt: z.number().int().min(1),
    statusCode: z.number().int().nullable(),
    latencyMs: z.number().int().min(0).nullable(),
    responseBody: z.string().max(2048).nullable(),
    nextRetryAt: isoDateSchema.nullable(),
    deliveredAt: isoDateSchema.nullable(),
    createdAt: isoDateSchema,
});
/** Exponential backoff schedule for failed webhook deliveries (ms), 5 attempts max. */
export const WEBHOOK_RETRY_SCHEDULE_MS = [10_000, 60_000, 300_000, 1_800_000, 7_200_000];
export function buildWebhookSignedPayload(timestamp, rawBody) {
    return `${timestamp}.${rawBody}`;
}
//# sourceMappingURL=webhook.js.map